module.exports = __webpack_public_path__ + "media/images/guideline/coupon-02-1ac47544b960f11f7aaae7e3421e361a.jpg";